(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGOVue"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOWebapi", "VueDemi", "FEGOVue", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-redpacket-prize-list/render"] = factory(require("FEGOWebapi"), require("VueDemi"), require("FEGOVue"), require("FEGORender"));
	else
		root["/fego/component/common-redpacket-prize-list/render"] = factory(root["FEGOWebapi"], root["VueDemi"], root["FEGOVue"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__9666__, __WEBPACK_EXTERNAL_MODULE__5322__) => {
return 